import request from "@/request/request.js";

// 公共
const common = {
  login(data) {
    return request({
      url: "/auth/login",
      method: "post",
      data,
    });
  },
  getAdminUserInfoByToken(data) {
    return request({
      url: "/auth/userInfoByToken",
      method: "get",
      params:data,
    });
  },
  getList(data) {
    return request({
      url: "/auth/list",
      method: "get",
      params:data,
      
    });
  },
  getRegionlist(data) {
    return request({
      url: "/auth/getRegionlist",
      method: "get",
      params:data,
      
    });
  },
  getTaglist(data) {
    return request({
      url: "/auth/getTaglist",
      method: "get",
      params:data,
      
    });
  },
};
const user = {
  
  getList(data) {
    return request({
      url: "/auth/list",
      method: "get",
      params:data,
    });
  },
  create(data) {
    return request({
      url: "/auth/create",
      method: "post",
      data,
    });
  },
  update(data) {
    return request({
      url: "/auth/upDate",
      method: "post",
      data,
    });
  },
  rePasw(data) {
    return request({
      url: "/auth/rePasw",
      method: "post",
      data,
    });
  },
  rename(data) {
    return request({
      url: "/auth/rename",
      method: "post",
      data,
    });
  },
  del(data) {
    return request({
      url: "/auth/delete",
      method: "post",
      data,
    });
  },
};
const appointment = {
  getList(data) {
    return request({
      url: "/appointment/adminlist",
      method: "get",
      params:data,
    });
  },
  update(data) {
    return request({
      url: "/answer/update",
      method: "post",
      data,
    });
  },
  del(data) {
    return request({
      url: "/appointment/delete",
      method: "post",
      data,
    });
  },
};
const activity = {
  getChildList(data) {
    return request({
      url: "/tag/getChildList",
      method: "get",
      params:data,
    });
  },
  getList(data) {
    return request({
      url: "/tag/list",
      method: "get",
      params:data,
    });
  },
  update(data) {
    return request({
      url: "/tag/update",
      method: "post",
      data,
    });
  },
  create(data) {
    return request({
      url: "/tag/add",
      method: "post",
      data,
    });
  },
  del(data) {
    return request({
      url: "/tag/delete",
      method: "post",
      data,
    });
  },
  
  answerAI(data) {
    return request({
      url: "/common/answerAI",
      method: "post",
      data,
    });
  },
  listhistoryAnswer(data) {
    return request({
      url: "/answer/list",
      method: "get",
      params:data,
    });
  },
};
export default {
  common,
  user,
  appointment,
  activity
};
